import { onMounted, onScopeDispose, ref } from 'vue';

interface ChangeBalanceVisibility {
    isVisibleViewBalance: boolean;
}

declare global {
    interface DocumentEventMap {
        'changeBalanceVisibility': CustomEvent<ChangeBalanceVisibility>;
    }
}


export const useShowBalance = (initialValue?: boolean) => {
    const showBalance = ref<boolean>(initialValue ?? (window as any).globalAppSettings.showBalance);

    // toggle balance visibility
    // should be called by changeBalanceVisibility event only
    const handleChangeShowBalance = (event: CustomEvent<ChangeBalanceVisibility>) => {
        const newValue = event.detail.isVisibleViewBalance;
        showBalance.value = newValue;
        (window as any).globalAppSettings.showBalance = newValue;
    };

    // publick api to change visiblity
    const toggleShowBalance = () => {
        // dispatch event on change balance visibility (listeners can be in history-app, for example)
        document.dispatchEvent(
            new CustomEvent<ChangeBalanceVisibility>('changeBalanceVisibility', {
                detail: {
                    isVisibleViewBalance: !showBalance.value,
                },
            })
        );
    };

    // add and remove events listeners (balance update, change balance visibility)
    onMounted(() => {
        document.addEventListener('changeBalanceVisibility', handleChangeShowBalance);
    });

    onScopeDispose(() => {
        document.removeEventListener('changeBalanceVisibility', handleChangeShowBalance);
    });


    return {
        showBalance,
        toggleShowBalance
    }
}